import { render, staticRenderFns } from "./MobileMenuButton.vue?vue&type=template&id=f4e510b8&scoped=true&"
import script from "./MobileMenuButton.vue?vue&type=script&lang=js&"
export * from "./MobileMenuButton.vue?vue&type=script&lang=js&"
import style0 from "./MobileMenuButton.vue?vue&type=style&index=0&id=f4e510b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e510b8",
  null
  
)

export default component.exports